import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const CellulitisPage = () => {
  const treatmentData = {
    title: "Cellulitis",
    description: "Cellulitis is a common bacterial skin infection that can cause pain, swelling, and redness. Our natural approach focuses on strengthening the immune system and using antimicrobial herbs to combat the infection while promoting healing.",
    causes: [
      "Bacterial infection (usually Streptococcus or Staphylococcus)",
      "Skin injuries or breaks",
      "Poor circulation",
      "Weakened immune system",
      "Chronic skin conditions"
    ],
    symptoms: [
      "Red, swollen skin",
      "Pain and tenderness",
      "Warmth in affected area",
      "Fever and chills",
      "Skin dimpling or pitting"
    ],
    approach: "Our treatment combines antimicrobial herbs, immune-boosting supplements, and topical applications to fight the infection naturally. We also focus on improving circulation and skin health to prevent recurrence.",
    benefits: [
      "Natural antimicrobial action",
      "Strengthens immune system",
      "Promotes faster healing",
      "Reduces risk of recurrence"
    ],
    lifestyleRecommendations: [
      "Keep skin clean and moisturized",
      "Protect skin from injuries",
      "Manage underlying conditions",
      "Maintain good hygiene practices"
    ],
    faqs: [
      {
        question: "How long does treatment take?",
        answer: "Most patients see improvement within 1-2 weeks, with complete healing typically taking 3-4 weeks."
      },
      {
        question: "Is this treatment safe for all ages?",
        answer: "Yes, our natural approach is gentle and suitable for all age groups."
      },
      {
        question: "Can I continue my regular medications?",
        answer: "Yes, our treatment can be safely combined with prescribed medications, but please inform us of all medications you're taking."
      }
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default CellulitisPage; 